import http from '../helpers/http';

export default class ThemeRepository {
    async getTheme(themeName) {
        
        if (themeName) {
            themeName = `${themeName}.`
        } else {
            themeName = '';
        }            

        let theme;

        try {            
            theme = await http.get(`/public/themes/${themeName}theme.json`);
        } catch (err) {
            console.error(err);
            theme = await http.get(`/public/themes/theme.json`);
        }
        
        return { data: theme };
    }
}